// import {
//   communityTabsLinking,
//   communityStackLinking,
// } from 'src/modules/community/communityLinking';
import { adminStackLinking, adminTabsLinking } from 'src/modules/admin/adminLinking';
import { examPreparationStackLinking, examPreparationTabsLinking, } from 'src/modules/exam-preparation/examPreparationLinking';
import { notificationStackLinking, notificationTabsLinking, } from 'src/modules/notification/notificationLinking';
import { reviewPipelineStackLinking } from 'src/modules/review-pipeline/reviewPipelineLinking';
import { stcTabsLinking } from 'src/modules/support-the-creators/stcLinking';
import { userStackLinking, userTabsLinking } from 'src/modules/user/userLinking';
import { FallbackRouteName } from '../config';
import { DLPrefix } from './constants';
const linking = {
    prefixes: [
        DLPrefix,
        'https://app.marinesamraj.com',
        'https://marinesamraj.page.link',
    ],
    config: {
        initialRouteName: 'Tabs',
        screens: {
            Tabs: {
                screens: {
                    // ...communityTabsLinking.screens,
                    ...userTabsLinking.screens,
                    ...notificationTabsLinking.screens,
                    ...examPreparationTabsLinking.screens,
                    ...stcTabsLinking.screens,
                    ...adminTabsLinking.screens,
                    [FallbackRouteName]: '*',
                },
            },
            // ...communityStackLinking.screens,
            ...examPreparationStackLinking.screens,
            ...userStackLinking.screens,
            ...notificationStackLinking.screens,
            ...reviewPipelineStackLinking.screens,
            ...adminStackLinking.screens,
        },
    },
};
export default linking;
